import { render, staticRenderFns } from "./PlayvoxLogo.vue?vue&type=template&id=6d898d72&"
import script from "./PlayvoxLogo.vue?vue&type=script&lang=js&"
export * from "./PlayvoxLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports